import {useMutation} from "@apollo/client";
import {CreateClientOrderInvoice, DeleteClientOrder, UpsertClient} from "../__generated__/types";
import {ClientUpdateMutation, ClientUpsertMutation} from "../shared/queries/client.gql";
import {ClientOrderDeleteMutation} from "../shared/queries/clientOrder.gql";

export const useClientUpdateMutation = () => useMutation<CreateClientOrderInvoice>(ClientUpdateMutation, {refetchQueries: 'active'});
export const useClientUpsertMutation = () => useMutation<UpsertClient>(ClientUpsertMutation, {refetchQueries: 'active'});
export const useClientOrderDeleteMutation = () => useMutation<DeleteClientOrder>(ClientOrderDeleteMutation, {refetchQueries: 'active'});
